import axios from "axios";
import { LocalStorage, SessionStorage } from "quasar";
import { baseurl } from "../config/api";

export const checkLoginUser = async () => {
  try {
    const staffName = LocalStorage.getItem("login_name");
    if (staffName && shouldCheck()) {
      LocalStorage.set("last_check", Date.now());
      await checkUserStatus(staffName);

      if (staffName === "admin") {
        logOut();
      }
    }
  } catch (error) {
    console.error("Error checking login user:", error);
  }
};

const checkUserStatus = async (staffName) => {
  const response = await axios.get(`${baseurl}/staff?staff_name=${staffName}`, {
    headers: {
      "Content-Type": 'application/json, charset="utf-8"',
      token: LocalStorage.getItem("openid"),
    },
  });
  if (response.data.results.length <= 0 || response.data.results[0].is_lock) {
    logOut();
  }
};

const logOut = () => {
  LocalStorage.remove("auth");
  LocalStorage.remove("login_name");
  LocalStorage.remove("login_id");
  SessionStorage.remove("axios_check");
  window.location.reload();
};

const shouldCheck = () => {
  const lastCheck = LocalStorage.getItem("last_check");
  if (!lastCheck) {
    return true;
  }
  const lastCheckTimestamp = Number(lastCheck);
  return Date.now() - lastCheckTimestamp > 300000;
};
